import { Button, Flex, Group } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import React, { useState } from "react";
import { FailedAlert } from "../../../../components";
import { useAppSelector } from "../../../../hooks";
import { sortArrayByString } from "../../../utils";
import MeetingDbFilterBar from "../MeetingSeries/MeetingDbFilterBar";
import NewMeetingInSeriesModal from "../NewMeetingInSeriesModal";
import { useGetMeetingSeriesQuery } from "../meetingSerieRTK";
import MeetingBoardsTable, { meetingBoardColumnDefs } from "./MeetingBoardsTable";

const MeetingBoards: React.FC<{}> = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const project = useAppSelector((state) => state.adminReducer.project);

  const { data: meetingSeries, isError: meetingSeriesError } = useGetMeetingSeriesQuery({
    projectId: project._id,
  });

  return (
    <Flex direction="column" h="100%" p="xs" style={{ overflow: "auto" }} w="100%">
      {meetingSeriesError === true && <FailedAlert errorMessage="Failed to fetch meeting series" />}
      <Group mb={"xs"} gap={"xs"}>
        <Button
          leftSection={<IconPlus size={16} style={{ marginRight: "-4px" }} />}
          color="green"
          variant="filled"
          size="sm"
          onClick={() => setModalOpen(true)}
        >
          Nytt møte
        </Button>
        <MeetingDbFilterBar columns={meetingBoardColumnDefs} />
      </Group>
      <NewMeetingInSeriesModal
        meetingSeries={sortArrayByString(meetingSeries, "name")}
        onClose={() => setModalOpen(false)}
        opened={modalOpen}
      />
      <MeetingBoardsTable />
    </Flex>
  );
};

export default MeetingBoards;
